import { render } from "./LegacyGroupReportTemplate.vue?vue&type=template&id=6d6b1b5b"
import script from "./LegacyGroupReportTemplate.vue?vue&type=script&lang=js"
export * from "./LegacyGroupReportTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__